import { bindLanguage, getLanguage, setLanguage } from "./core/i18n.js";
import { publicPage } from "../shared/public-content.js";
import { legalPage } from "../shared/legal-content.js";
import "./styles/legal.css";
import "./styles/original.css";
import "./styles/product.css";
import "./styles/motion.css";
import "./styles/auth.css";
import "./styles/dayx.css";
import "./styles/landing-demos.css";
import "./styles/landing-product-demos.css";
import "./styles/guide-examples.css";
import "./styles/night.css";
import "./styles/appearance.css";
import { bindAppearance } from "./features/appearance.js";
import { syncLandingAccount } from "./features/landing-account.js";
import { bindLandingDemos } from "./features/landing-demos.js";
import { bindPresence } from "./services/presence.js";

const guide = publicPage(location.pathname);
const legal = legalPage(location.pathname);
const page = guide || legal;
bindAppearance();
if (page) {
  document
    .querySelectorAll('a[href="/signup"]')
    .forEach((link) => (link.dataset.accountCta = "true"));
  fetch("/api/session", { credentials: "same-origin", cache: "no-store" })
    .then((response) => (response.ok ? response.json() : null))
    .then((session) => {
      syncLandingAccount(document.getElementById("welcome"), session?.user);
      if (session) bindPresence(session);
    })
    .catch(() => {});
  setLanguage(page.language, { remember: false });
  bindLanguage();
  window.addEventListener("dayx:language", () => {
    location.assign(`/${getLanguage()}/${guide ? guide.topic.id : legal.id}`);
  });
  const header = document.querySelector(".dayx-landing-nav");
  const welcome = document.getElementById("welcome");
  bindLandingDemos(welcome);
  const updateScroll = () =>
    header.classList.toggle("is-scrolled", window.scrollY > 8);
  updateScroll();
  window.addEventListener("scroll", updateScroll, { passive: true });
  new ResizeObserver(() =>
    welcome.style.setProperty(
      "--landing-header-height",
      `${header.offsetHeight}px`,
    ),
  ).observe(header);
}
